import {
  Box,
  TextField,
  InputAdornment,
  Button,
  Popover,
  MenuItem,
  Typography,
  FormControl,
  Select,
  Grid,
  Divider,
  LinearProgress,
  InputLabel,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
// import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FormComponent from './Form';
import { useTranslation } from 'react-i18next';
import { numberFormat } from '../../utils/nunberFormat';
import AddIcon from '@mui/icons-material/Add';
import Pagination from '@mui/material/Pagination';
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import usePromotionController from './controller';
import { EN_ACCEPT_LANGUAGE } from '../../constants/acceptLanguageApi';
import PromotionTabPanel from './components/tabPanel';
import { PromotionEnumType } from '../../enums/promotionEnum';
import ConfirmDialog from '../../components/ConfirmDialog';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';
import TagPromotionComponent from './tagPromotion';
import SellIcon from '@mui/icons-material/Sell';
import TableXGetXPromotionComponent from './components/table/TableXgetX';
import TableXGetYPromotionComponent from './components/table/TableXgetY';
import TableDsComponent from './components/table/TableDs';
import TableCSTByUnitComponent from './components/table/TableCstByUnit';
import TableCSTByAmountComponent from './components/table/TableCstByAmount';
import TableSPPPromotionComponent from './components/table/TableSPP';
import TableRDComponent from './components/table/TableRD';
import TableCBDComponents from './components/table/TableCBD';
import TableCBPComponent from './components/table/TableCBP';
import DetailsIcon from '@mui/icons-material/Details';
import SelectedBranchComponentVoid from '../../components/SelectedBranchVoid';
const PromotionView = () => {
  const { t, i18n } = useTranslation('global');

  const controller = usePromotionController();

  const useRenderTable = () => {
    switch (controller.promotionType) {
      case PromotionEnumType.buy_x_get_x:
        return (
          <TableXGetXPromotionComponent
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      case PromotionEnumType.buy_x_get_y:
        return (
          <TableXGetYPromotionComponent
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      case PromotionEnumType.buy_x_get_ds:
        return (
          <TableDsComponent
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      case PromotionEnumType.buy_x_set_a_get_rd:
        return (
          <TableRDComponent
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      case PromotionEnumType.buy_x_set_u_get_cbd:
        return (
          <TableCBDComponents
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      case PromotionEnumType.buy_x_set_a_get_cbp:
        return (
          <TableCBPComponent
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      case PromotionEnumType.buy_x_set_u_get_cst_by_unit:
        return (
          <TableCSTByUnitComponent
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      case PromotionEnumType.buy_x_set_a_get_cst_by_price:
        return (
          <TableCSTByAmountComponent
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      case PromotionEnumType.buy_x_u_get_spp:
        return (
          <TableSPPPromotionComponent
            rows={controller.rows}
            currentPage={controller.currentPage}
            handleOpenMenu={controller.handleOpenMenu}
            isSearchNotFound={controller.isSearchNotFound}
            searchValue={controller.searchValue}
          />
        );
      default:
        return null;
    }
  };

  const renderTable = useRenderTable();

  return (
    <Box>
      {!controller.openTagPromotion ? (
        <>
          {!controller.openForm ? (
            <Box>
              {controller.loadingPage ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <LoadingAnimatedIcon />
                </Box>
              ) : (
                <>
                  <Box mb={2} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: 2,
                        width: '100%',
                      }}
                    >
                      <Typography color={TEXT_TITLE_COLOR} fontWeight="bold" fontSize={35}>
                        {t('promotion_page.Promotion')}
                      </Typography>

                      <TextField
                        fullWidth
                        sx={{ maxWidth: 250 }}
                        placeholder={`${t('promotion_page.Search Promotion Name')} ...`}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        size="small"
                        value={controller.searchValue}
                        onChange={controller.handleSearchValue}
                      />

                      <Box sx={{ width: 200 }}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="merchant-label-id" shrink={true}>
                            {t('Branch')}
                          </InputLabel>
                          <Select
                            labelId="merchant-label-id"
                            id="merchant-id"
                            label="Merchant"
                            value={controller.branchValue}
                            onChange={(e) => controller.handleSelectedBranch(e.target.value)}
                            sx={{
                              bgcolor: SELECT_BACKGROUND_COLOR,
                              '.MuiOutlinedInput-notchedOutline': { border: 0 },
                              borderRadius: '8px',
                            }}
                          >
                            <MenuItem value="All">{t('branchManage_page.All branch')}</MenuItem>
                            {controller.branchData?.map((branch) => (
                              <MenuItem key={branch.id} value={branch.id}>
                                {i18n.language === EN_ACCEPT_LANGUAGE
                                  ? branch?.nameEn
                                  : branch?.nameLa}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>

                  <Box mb={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4}>
                        <Box
                          sx={{
                            backgroundColor: '#C4EAFF',
                            borderRadius: '16px',
                            p: 4,
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Box>
                            <Typography color="#7A4100" sx={{ mb: 1 }}>
                              {t('promotion_page.All Promotion')}
                            </Typography>
                            <Typography color="#7A4100" fontWeight="bold" fontSize={28}>
                              {numberFormat(controller.countPromotion)}{' '}
                              {t('promotion_page.Promotion')}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'end', flexWrap: 'wrap', mb: 2, gap: 1 }}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ textTransform: 'none', color: 'white' }}
                      onClick={controller.handleOpenTagPromotion}
                    >
                      <SellIcon /> &nbsp;&nbsp;{t('promotion_page.Tag Promotion')}
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ textTransform: 'none', color: 'white' }}
                      onClick={controller.handleOpenForm}
                    >
                      <AddIcon /> &nbsp;&nbsp;{t('promotion_page.Create Promotion')}
                    </Button>
                  </Box>
                  <Box mb={2}>
                    <PromotionTabPanel
                      value={controller.promotionType}
                      onChange={controller.handleSelectPromotionType}
                    />
                  </Box>

                  {controller.loadingData ? (
                    <LinearProgress />
                  ) : (
                    <Box>
                      {renderTable}
                      <Divider />
                      <Box sx={{ display: 'flex', justifyContent: 'end', mt: 1 }}>
                        <Pagination
                          count={controller.countPagination}
                          onChange={controller.handleChangePage}
                          page={controller.currentPage}
                          color="primary"
                        />
                      </Box>
                    </Box>
                  )}

                  <Popover
                    open={Boolean(controller.openMenu)}
                    anchorEl={controller.openMenu}
                    onClose={controller.handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                      sx: {
                        p: 1,
                        width: 140,
                        '& .MuiMenuItem-root': {
                          px: 1,
                          typography: 'body2',
                          borderRadius: 0.75,
                        },
                      },
                    }}
                  >
                    <MenuItem sx={{ color: '#737373' }} onClick={() => controller.handleOpenDetailForm()}>
                      <DetailsIcon />
                      &nbsp;&nbsp;
                      {t('promotion_page.Detail')}
                    </MenuItem>
                    <MenuItem
                      sx={{ color: 'error.main' }}
                      onClick={() => controller.handleOpenDeleteForm()}
                    >
                      <DeleteIcon />
                      &nbsp;&nbsp;
                      {t('Delete')}
                    </MenuItem>
                  </Popover>
                  <ConfirmDialog
                    open={controller.openDeleteForm}
                    title={t("Do you want to delete this promotion")}
                    loading={controller.loadingDeleteButton}
                    onCancel={controller.handleCloseDeleteForm}
                    onConfirm={() => controller.handleDeletePromotion()}
                  />
                </>
              )}
            </Box>
          ) : (
            <FormComponent
              onClose={controller.handleCloseForm}
              onFetchData={controller.handleGetData}
              selectPromotionType={controller.promotionType}
              branchValue={controller.branchValue}
              branchData={controller.branchData}
              tagPromotionData={controller.tagPromotionData}
              selectedData={controller.selectedPromotionData}
            />
          )}
        </>
      ) : (
        <TagPromotionComponent
          onCloseForm={controller.handleCloseTagPromotion}
          data={controller.tagPromotionData}
          onFetchTagPromotionData={controller.handleGetTagPromotionData}
        />
      )}
    </Box>
  );
};
export default PromotionView;
